import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { aboutContent, brand } from '../mock/mockData';

export default function About() {
  return (
    <div className="pt-24">
      {/* Hero band */}
      <section className="relative py-28 md:py-36 bg-forest-950">
        <div className="absolute inset-0 opacity-20">
          <img src="https://images.unsplash.com/photo-1521587760476-6c12a4b040da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxsYXclMjBvZmZpY2V8ZW58MHx8fHwxNzg1OTY3NjA3fDA&ixlib=rb-4.1.0&q=85" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-forest-950 via-forest-950/70 to-forest-950" />
        </div>
        <div className="relative max-w-5xl mx-auto px-6 md:px-10">
          <p className="text-sage-400 tracking-[0.3em] text-xs uppercase mb-5 reveal">{brand.tagline}</p>
          <h1 className="font-serif text-cream-50 text-5xl md:text-7xl leading-tight reveal" style={{transitionDelay:'120ms'}}>{aboutContent.title}</h1>
        </div>
      </section>

      {/* Story */}
      <section className="bg-forest-900 py-20">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <h2 className="section-title font-serif text-cream-50 text-3xl md:text-4xl reveal">{aboutContent.story.heading}</h2>
          <div className="mt-8 space-y-6 text-cream-100/80 text-base md:text-lg leading-relaxed reveal" style={{transitionDelay:'100ms'}}>
            {aboutContent.story.body.map((p) => (<p key={p.slice(0, 40)}>{p}</p>))}
          </div>
        </div>
      </section>

      {/* Approach */}
      <section className="bg-forest-950 py-20">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <h2 className="section-title font-serif text-cream-50 text-3xl md:text-4xl reveal">{aboutContent.approach.heading}</h2>
          <div className="mt-8 space-y-6 text-cream-100/80 text-base md:text-lg leading-relaxed reveal" style={{transitionDelay:'100ms'}}>
            {aboutContent.approach.body.map((p) => (<p key={p.slice(0, 40)}>{p}</p>))}
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
            {['Lexcel accredited', 'Conveyancing Quality Scheme', 'Grade 1 Chambers ranking (Social Housing, Thames Valley)', 'Trusted by 40+ Housing Associations'].map((item) => (
              <div key={item} className="flex gap-3 items-start reveal">
                <CheckCircle2 className="h-5 w-5 text-sage-400 mt-0.5 flex-shrink-0" />
                <span className="text-cream-100/85">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-forest-800 py-16">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <h3 className="font-serif text-cream-50 text-3xl md:text-4xl">Ready to talk?</h3>
          <p className="mt-4 text-cream-100/75">Whether you're near us, in London, or further afield, we'd love to hear from you.</p>
          <Link to="/contact" className="mt-8 inline-flex items-center gap-3 bg-sage-500 text-forest-900 px-8 py-4 text-sm font-medium tracking-wide hover:bg-sage-600 transition-colors">
            Get in touch <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
